import { OktaAuth } from '@okta/okta-auth-js';
import { oktaConfig } from '../config/oktaConfig';

const oktaAuth = new OktaAuth(oktaConfig);

export const handleTokenRenewal = async () => {
  try {
    const accessToken = await oktaAuth.tokenManager.get('accessToken');
    
    if (accessToken && accessToken.expiresAt) {
      const expInMills = accessToken.expiresAt * 1000;
      const balanceTimeInMins = (expInMills - Date.now()) / (1000 * 60);

      if (balanceTimeInMins < 5) {
        const renewedTokens = await oktaAuth.tokenManager.renew('accessToken');
      }
    }
  } catch (error) {
    console.error('Error during token renewal:', error);
  }
};
